<script setup lang="ts">
import InfoModalBtnArea from '@/components/AccountParts/InfoModalBtnArea.vue';
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: boolean
  roleAssignAuthority: boolean
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})
</script>
<template>
  <InfoModal
    v-model="modelValue"
    modalWidth="30%"
  >
    <template v-slot:text>
      <div>
        <h4>{{ i18n.global.t('pages.accounts.InfoModal.infoMessagesRow1') }}</h4>
        <h4 class="mt-2">{{ i18n.global.t('pages.accounts.InfoModal.infoMessagesRow2') }}</h4>
      </div>
    </template>
    <template v-slot:footer>
      <InfoModalBtnArea
        :roleAssignAuthority="props.roleAssignAuthority"
      />
    </template>
  </InfoModal>
</template>
